import Category from "../model/category";
import SchemaObject from "../model/schemaObject";
import getMarkers from "./getMarkers";
import resolveRefs from "./resolveRefs";
import searchKeyInCollection from "./searchKeyInCollection";

export default async function getMarkersCategory(category: string): Promise<Category> {
    const markers = await getMarkers();

    const categoryMarkers = searchKeyInCollection(markers.categories, category);

    if (!categoryMarkers) {
        throw new Error(`Category ${category} not found`);
    }

    return {
        ...categoryMarkers,
        d: resolveRefs(categoryMarkers.d, markers.schemas) as SchemaObject
    }
}